"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TileGoToButton_styles_1 = require("./TileGoToButton.styles");
exports.default = (function (_a) {
    var Disabled = _a.Disabled, OnClick = _a.OnClick, AriaLabel = _a.AriaLabel, Title = _a.Title, Caption = _a.Caption;
    return (React.createElement(TileGoToButton_styles_1.default, { disabled: Disabled, "aria-label": AriaLabel, title: Title, type: "button", onClick: OnClick }, Caption));
});
